import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type { GetZuubInsuranceDetailResponseV3 } from '../@types/zuub/contracts';

import { makeAPIRequestReactQueryWithHeaders } from './api';
import { endpoints } from './endpoints';

interface UseGetZuubInsuranceDetailParams {
  pmsPatientId: string | undefined;
  enabled?: boolean;
}

export const useGetZuubInsuranceDetail = ({
  pmsPatientId,
  enabled = true,
}: UseGetZuubInsuranceDetailParams) => {
  const {
    primaryPracticeId: practiceId,
    primaryOrganizationId: organizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery(
    [endpoints.zuubInsuranceDetailV3, pmsPatientId],
    () => {
      return makeAPIRequestReactQueryWithHeaders<GetZuubInsuranceDetailResponseV3>(
        `${endpoints.zuubInsuranceDetailV3}/${pmsPatientId}`,
        {},
        {
          Org: organizationId,
          Practice: practiceId,
        },
        'GET',
      );
    },
    {
      enabled: enabled && !!pmsPatientId,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );
};
